import * as React from 'react'

import { getLazyImageObserver } from './getLazyImageObserver'

type LazyImageProps = {
  nativeLazyLoad?: boolean
  children: React.ReactElement<{ tagName: 'IMG'; src: string; ref: React.Ref<HTMLImageElement>; loading?: string }>
}

export function LazyImage({
  nativeLazyLoad,
  children,
}: LazyImageProps): React.ReactElement<{ tagName: 'IMG'; src: string; ref: React.Ref<HTMLImageElement> }> {
  const imageRef = React.useRef<HTMLImageElement>(null)
  const lazyImageObserver = getLazyImageObserver()

  const src = children.props.src

  React.useEffect(() => {
    if (nativeLazyLoad) {
      return
    }

    if (imageRef.current !== null) {
      imageRef.current.dataset.src = src
      lazyImageObserver.observe(imageRef.current)
    }

    return () => {
      if (imageRef.current !== null) {
        lazyImageObserver.unobserve(imageRef.current)
      }
    }
  }, [])

  if (nativeLazyLoad) {
    return React.cloneElement(children, { loading: 'lazy' })
  } else {
    return React.cloneElement(children, { src: '', ref: imageRef })
  }
}
